
/* injects from baggage-loader */

'use strict';

import footerTpl from './footer.html';
import FooterController from './footer.controller';

export default class FooterComponent {
    constructor() {
        this.templateUrl = footerTpl;
        this.controller = FooterController;
        this.controllerAs = 'ctrl';
    }
}


// WEBPACK FOOTER //
// ./src/app/components/footer/footer.component.js